import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { DataService } from '@Core/services/proprietary/data.service';
import { Datasource, DataSourceStatus } from '@Core/services/proprietary/datasource';
import { UpdateContract } from './contract.actions';

@Injectable()
export class ContractHelperService {
    private dsDBObjectType: Datasource;
    private dsDBObjectTypeSub: Subscription;

    constructor(private store: Store, private ds: DataService) { }

    initializeService(objectType: string) {
        this.dsDBObjectType = this.ds.addNewDatasource(objectType);
    }

    endService() {
        if (this.dsDBObjectTypeSub) {
            this.dsDBObjectTypeSub.unsubscribe();
        }
        if (this.dsDBObjectType) {
            this.ds.deleteDatasource(this.dsDBObjectType);
        }
    }

    setTaxesFiledByIfBrokerIsTaxFiler(brokerEntityID: any) {
        let criteria: any = {
            View: 'Full',
            json: 'CT2',
            Affiliate_Options: '[NONE]',
            Phone_Options: '[NONE]',
            Address_Options: '[NONE]',
            Email_Options: '[NONE]'
        };
        criteria.Entity_ID = brokerEntityID;

        this.dsDBObjectType.get(criteria, true, false);
        this.dsDBObjectTypeSub = this.dsDBObjectType.status$.subscribe((status) => {
            switch (status) {
                case DataSourceStatus.Ready:
                    if (this.dsDBObjectType && this.dsDBObjectType.objectNode) {
                        this.store.dispatch(new UpdateContract({ Tax_Filed_By_Role: 'BK' }));
                    }
                    this.endService();
                    break;
                case DataSourceStatus.Error:
                    this.endService();
                    break;
            }
        });
    }
}
